export default __webpack_public_path__ + "static/media/WebIntro.7da5c340.mp4";